import { html, css, LitElement, unsafeCSS } from 'lit';
import { domReady } from './artistutils'
import { addClickEvent } from './googletrack'

/*
Handle favourites wherever they are selected/unselected
*/

export class Favourites extends LitElement {
    favourites = []
    removeEventName = 'remove:favourite'

    constructor() {
        super()
    }

    clickedOnItinerary(e, logo) {
        var result = false;
        if (logo) {
            var rect = logo.getBoundingClientRect();
            var areaWidth = 70;
            result = (rect.right - e.clientX <= areaWidth && rect.right - e.clientX >= 0) && (e.clientY - rect.top <= areaWidth && e.clientY - rect.top > 0);
        }
        //console.log("Itinerary", result)
        return result;
    }

    clearFavourites() {
        this.favourites = []
        this.saveFavourites()
        this.updateDom()
    }



    setFavourites(favs) {
        this.favourites = []
        favs.forEach(fav => {
            this.favourites.push(fav)
        })
        this.saveFavourites()
    }

    addFavourite(artistId, callback) {
        console.log("Add", artistId)

        if (!this.favourites.includes(artistId)) {
            this.favourites.push(artistId);
        }
        this.saveFavourites(() => {
            this.updateDom()
            if (callback) callback();
        })
    }

    addFavouriteClickEvent(artistName) {
        addClickEvent("add_favourite", artistName)
    }

    removeFavouriteClickEvent(artistName) {
        addClickEvent("remove_favourite", artistName)
    }

    removeFavourite(artistId, callback) {
        console.log("REMOVE", artistId)
        const removeEvent = new CustomEvent(this.removeEventName, {
            detail: { artistId: artistId },
            bubbles: true // Allows event to travel up the DOM tree
        });
        
        if (this.favourites.includes(artistId)) {
            ///console.log("favouriote excluded")
            this.favourites = this.favourites.filter(p => p != artistId);
        }
        this.saveFavourites(() => {
            this.updateDom()
            document.dispatchEvent(removeEvent)
            if (callback) callback();
        })
    }


    async addClickHandlers() {
        await domReady();
        document.addEventListener("click", (e) => {
            //console.log("click happened")
            const logo = event.target.closest('.logo');
            if (logo) {
                const itinerary = logo.querySelector('.artist-itinerary');
                if (itinerary) {
                    //console.log("clicked on logo")
                    if (this.clickedOnItinerary(e, logo)) {
                        event.preventDefault();
                        const artistId = parseInt(itinerary.dataset.artistid)
                        const artistName = itinerary.dataset.name
                        if (!this.favourites.includes(artistId)) {
                            const btn = itinerary.closest(".logo");
                            this.itineraryAnimation(btn)
                            this.addFavouriteClickEvent(artistName)
                            this.addFavourite(artistId);
                        } else {
                            //this.favourites = this.favourites.filter(p => p != artistId)
                            this.removeFavouriteClickEvent(artistName)
                            this.removeFavourite(artistId)
                        }
                        // this.saveFavourites(() => {
                        //     this.updateDom()
                        // })
                        //console.log("Clicked on artist:", artistId);
                        //const btn = itinerary.closest(".logo");
                        //this.itineraryAnimation(btn)
                    } else {
                        //console.log("NOT ITINERARY");
                    }
                }
            }
        })

        //    document.querySelectorAll('a.artist').forEach(artist => {
        //        artist.addEventListener('click', (e) => {
        //            if (this.clickedOnItinerary(e, artist)) {
        //                e.preventDefault();
        //                const btn = artist.querySelector(".logo");
        //                this.itineraryAnimation(btn, () => {
        //                    const artistId = parseInt(artist.dataset.artistid);                         
        //                    if (!this.favourites.includes(artistId)) {
        //                        this.addFavourite(artistId);  
        //                    } else {
        //                        this.favourites = this.favourites.filter(p => p != artistId)
        //                    }
        //                    this.saveFavourites(() => {
        //                        this.updateDom()
        //                    })
        //                });

        //                console.log("Clicked on artist:", artist);
        //            }
        //        })
        //    })
    }
    removeWithAnimation(el) {
        // 1. Create the animation
        const animation = el.animate([
            { opacity: 1, transform: 'scale(1)' }, // Start state
            { opacity: 0, transform: 'scale(0)' }  // End state
        ], {
            duration: 500,
            easing: 'ease-out'
        });

        // 2. Wait for it to finish before removing from DOM
        animation.onfinish = () => el.remove();
    }

    updateDom() {
        //console.log("Updating DOM with favourites:", this.favourites);
        // update dom to reflect favourites (e.g., change button state)

        document.querySelectorAll('a.artist').forEach(artist => {
            artist.classList.remove("selected");
            const artistId = parseInt(artist.dataset.artistid);
            if (this.favourites.includes(artistId)) {
                artist.classList.add("selected");
            }
        })
        document.querySelectorAll('.artist-profile').forEach(artist => {
            artist.classList.remove("selected");
            const artistId = parseInt(artist.dataset.artistid);
            if (this.favourites.includes(artistId)) {
                artist.classList.add("selected");
            }
        })
        document.querySelectorAll('.member-itinerary').forEach(it => {
            it.querySelectorAll('.artist').forEach(artist => {
                const artistId = parseInt(artist.dataset.artistid);              
                if (!this.favourites.includes(artistId)) {
                    this.removeWithAnimation(artist)
                }
            })
        })

        const itineraryPanel = document.querySelector(".main-header .itinerary");
        if (itineraryPanel) {
            const itemsEl = itineraryPanel.querySelector(".itinerary-items")
            itemsEl.style.display = "none"
            if (this.favourites.length > 0) {
                itemsEl.querySelector(".number").textContent = this.favourites.length
                itemsEl.style.display = ""
            }
        }
    }

    async saveFavourites(callback) {
        this.saveCookie()
        try {
            //console.log("Saving favourites to API", this.favourites);
            const response = await fetch('/api/MemberApi/favourites', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(this.favourites) // Body data must be a string
            })

            // Check if the request was successful
            if (!response.ok) throw new Error('Network response was not ok');

            const data = await response.json(); // Wait for the JSON body to parse
            //console.log("Save Favourites from API", data);

            if (callback) callback();

        } catch (error) {
            console.error("Failed to fetch favourites:", error);
        }
    }

    async fetchFavourites(callback) {
        try {
            const response = await fetch('/api/MemberApi/favourites');

            // Check if the request was successful
            if (!response.ok) throw new Error('Network response was not ok');

            const data = await response.json(); // Wait for the JSON body to parse

            console.log("Favourites from API", data);
            if (data && data.member && data.favourites) {
                this.favourites = data.favourites;
            } else {
                console.log("getting cookie", this.favourites)
                this.favourites = await this.getCookie()
                console.log("got cookie", this.favourites)
            }
            //console.log("Final favourites list after fetch:", this.favourites);
            if (callback) callback();

        } catch (error) {
            console.error("Failed to fetch favourites:", error);
        }
    }

    async init() {
        this.addClickHandlers()
        await this.fetchFavourites(() => { this.updateDom() })
        window.addEventListener("routechanged", (event) => {
            console.log("Route changed", event.detail, this.favourites);
            const orderedStrings = event.detail || []
            if (orderedStrings.length) {

                const newOrderMap = new Map(event.detail.map((id, index) => [id, index]));
                const present = [];
                const missing = [];
                for (const id of this.favourites) {
                    if (newOrderMap.has(id)) {
                        present.push(id);
                    } else {
                        missing.push(id);
                    }
                }
                present.sort((a, b) => newOrderMap.get(a) - newOrderMap.get(b));
                this.favourites = [...present, ...missing];

                console.log(this.favourites)
                const listContainer = document.querySelector('#favourites-list > .artists');

                const favsByListingNumber = []
                this.favourites.forEach(id => {
                    if (!favsByListingNumber.includes(id)) {
                        const element = document.querySelector(`[data-artistid="${id}"]`)
                        const listing = element.dataset.listingnumber
                        if (listing) {
                            const elements = document.querySelectorAll(`[data-listingnumber="${listing}"]`)
                            elements.forEach(el => {
                                const id = parseInt(el.dataset.artistid)
                                favsByListingNumber.push(id)
                            })
                        } else {
                            favsByListingNumber.push(id)
                        }
                    }
                })
                console.log("fbl", favsByListingNumber, this.favourites)
                this.favourites = favsByListingNumber

                this.favourites.forEach(id => {

                    // Find the actual HTML element on the page matching this ID
                    const element = document.querySelector(`[data-artistid="${id}"]`);

                    if (element) {
                        listContainer.appendChild(element);
                    }
                });


                console.log("route changed", this.favourites)
                this.saveFavourites()
                //this.updateDom()

            }
        })
    }

    CookieName = "FAVOURITES";

    saveCookie() {
        const jsonString = JSON.stringify(this.favourites);
        const days = 400;
        const maxAge = days * 24 * 60 * 60;

        document.cookie = `${this.CookieName}=${encodeURIComponent(jsonString)}; max-age=${maxAge}; path=/; SameSite=Lax; Secure`;
        console.log("cookie set to ", jsonString)
    }

    async getCookie() {
        const response = await fetch('/api/MemberApi/artists');
        const artists = await response.json();

        console.log("Getting cookie for name:", this.CookieName);
        const cookieMatch = document.cookie.match(new RegExp('(^| )' + this.CookieName + '=([^;]+)'));
        if (cookieMatch) {
            try {
                // Use index [2] to get the value group from the Regex
                const ids = JSON.parse(decodeURIComponent(cookieMatch[2]))
                const filteredIds = [];
                ids.forEach(id => {
                    const artist = artists.find(p => parseInt(p.id) == id)
                    if (artist) {
                        filteredIds.push(id)
                    }
                })
                return filteredIds;
            } catch (e) {
                console.error("Error parsing cookie array", e);
                return [];
            }
        }
        return [];
    }

    itineraryAnimation(button, callback) {
        //console.log("Starting itinerary animation for button:", button);
        const itineraryPanel = document.querySelector(".main-header .itinerary");
        const imgToDrag = button.querySelector("img.unselected");

        if (imgToDrag && itineraryPanel) {
            const rect = imgToDrag.getBoundingClientRect();
            const panelRect = itineraryPanel.getBoundingClientRect();

            // Create clone and set initial styles
            const imgClone = imgToDrag.cloneNode(true);

            // Remove specific sub-elements if they exist in the clone
            const subElement = imgClone.querySelector(".artist-itinerary");
            if (subElement) subElement.style.display = "none";

            Object.assign(imgClone.style, {
                opacity: "0.8",
                position: "fixed", // Use fixed to match getBoundingClientRect coordinates
                top: `${rect.top}px`,
                left: `${rect.left + rect.width - 34}px`,
                height: "34px",
                width: "34px",
                zIndex: "100",
                pointerEvents: "none"
            });

            document.body.appendChild(imgClone);

            // Web Animations API (Native replacement for .animate)
            const animation = imgClone.animate([
                { // Keyframe: Start
                    top: `${rect.top}px`,
                    left: `${rect.left + rect.width - 34}px`,
                    width: "34px",
                    height: "34px",
                    opacity: 0.8
                },
                { // Keyframe: End
                    top: `${panelRect.top + 10}px`,
                    left: `${panelRect.left + 10}px`,
                    width: "0px",
                    height: "0px",
                    opacity: 0
                }
            ], {
                duration: 1000,
                easing: "cubic-bezier(0.87, 0, 0.13, 1)" // Closest to easeInOutExpo
            });

            // Cleanup on finish
            animation.onfinish = () => {
                imgClone.remove();
                if (typeof callback === "function") callback();
            };
        }
    }
    render() {
        return html`
        <div>This is the favourites element</div>
        `
    }

}
customElements.define('favourites-element', Favourites);
const favouritesEl = document.createElement('favourites-element');
await favouritesEl.init()
export { favouritesEl }

